import Vue from "vue";

import "core-js/stable";
import "regenerator-runtime/runtime";

import axios from "axios";
import {
    TablePlugin,
    TableSimplePlugin,
    FormPlugin,
    FormInputPlugin,
    InputGroupPlugin,
    FormSelectPlugin,
    FormGroupPlugin,
    FormRadioPlugin,
    FormCheckboxPlugin,
    FormTextareaPlugin,
    FormTagsPlugin,
    LayoutPlugin,
    NavPlugin,
    ListGroupPlugin,
    AlertPlugin,
    BadgePlugin,
    ButtonPlugin,
    CardPlugin,
    TooltipPlugin,
    CollapsePlugin
} from "bootstrap-vue";
import collectjs from "collect.js";
import Clipboard from "v-clipboard";
import VueNotifications from "vue-notification";
import VueModal from "vue-js-modal";
import VueMultiselect from "vue-multiselect";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import VueScrollTo from "vue-scrollto";
import VueProgressBar from "vue-progressbar";
import ToggleButton from "vue-js-toggle-button";
const VueQrcode = () => import("@chenfengyuan/vue-qrcode");
import moment from "moment";

import { library } from "@fortawesome/fontawesome-svg-core";
// prettier-ignore
import { faBars, faBug, faLink, faSpinner, faBan, faCheck, faCopy, faTimes, faShoppingCart, faComments, faBirthdayCake, faToolbox, faSearch, faEdit, faCode, faArrowDown, faArrowUp, faCaretLeft, faEye} from "@fortawesome/free-solid-svg-icons";
// prettier-ignore
import { faInfoSquare, faExclamationSquare, faCheckSquare, faTimesSquare, faClone, faPlusSquare, faWindowRestore, faSave, faUsers, faServer, faCubes, faCog, faEllipsisV, faLock, faInfinity, faLockAlt, faLockOpenAlt } from "@fortawesome/pro-regular-svg-icons";
import { faLaravel, faWordpress, faDrupal, faYelp, faJoomla, faWikipediaW } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// config
import certificates from "./config/certificates";

import Loader from "./components/Loader.vue";
import CcsModal from "./components/CcsModal.vue";

import App from "./app.vue";
import router from "./router";
import store from "./store";
import laroute from "./laroute";
import generatePassword from "@/helpers/PasswordGenerator";

Vue.use(TablePlugin);
Vue.use(TableSimplePlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(InputGroupPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormTagsPlugin);
Vue.use(LayoutPlugin);
Vue.use(NavPlugin);
Vue.use(ListGroupPlugin);
Vue.use(AlertPlugin);
Vue.use(BadgePlugin);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);

Vue.use(VueNotifications, { componentName: "vue-notifications" });
Vue.use(VueModal, { dialog: true, dynamic: true });
Vue.use(Vuelidate);
Vue.use(ToggleButton);
Vue.use(VueSweetalert2);
Vue.use(VueScrollTo);
Vue.use(VueProgressBar, {
    color: "#37bc9b",
    failedColor: "#ff5454",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    location: "top",
});
Vue.use(Clipboard);

// prettier-ignore
library.add(faBars, faBug, faLink, faSpinner, faInfoSquare, faBan, faLaravel,
    faWordpress, faExclamationSquare, faCheck, faCheckSquare, faTimesSquare, faCopy,
    faTimes, faDrupal, faShoppingCart, faComments, faYelp, faBirthdayCake, faToolbox,
    faJoomla, faPlusSquare, faSearch, faClone, faWindowRestore, faEdit, faSave, faWikipediaW,
    faCode, faArrowDown, faArrowUp, faUsers, faServer, faCubes, faCog, faEllipsisV, faLock, faInfinity,
    faCaretLeft, faEye, faLockAlt, faLockOpenAlt
);

Vue.component("multiselect", VueMultiselect);
Vue.component("fa", FontAwesomeIcon);
Vue.component("loader", Loader);
Vue.component("ccs-modal", CcsModal);
Vue.component(VueQrcode.name, VueQrcode);

Vue.prototype.$axios = axios;
Vue.prototype.$laroute = laroute;
Vue.prototype.$collect = collectjs;
Vue.prototype.$generatePassword = generatePassword;
Vue.prototype.$moment = moment;

Vue.prototype.$config = {
    certificates: certificates
};


new Vue({
    el: "#app",
    router,
    store,
    render: (h) => h(App),
});
